import styled, { css } from 'styled-components';

interface Props {
  errorMessage?: string;
}

export const OTPValue = styled.input<Props>`
  width: 40px !important;
  height: 40px;
  text-align: center;
  border-radius: 4px;
  border: 1px solid #666666;
  ${props =>
    props.errorMessage &&
    css`
      border-image: none;
      border: 1px solid red;
    `}
  font-size: 21px;
  @media (max-width: 650px) {
    width: 33px !important;
    height: 33px;
  }
  &:focus,
  &:hover {
    outline: none;
    border: ${props =>
      !props.errorMessage ? '1px solid #0669de' : '1px solid red'};
  }
`;

export const OTPLabel = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #666666;
  text-align: left;
  margin-bottom: 6.5px;
`;

export const OTPContainer = styled.div`
  width: 100%;
  text-align: center;
`;

export const ErrorMessage = styled.div`
  font-size: 14px;
  line-height: 16px;
  width: 90%;
  margin-top: 5px !important;
  color: red;
  @media (max-width: 650px) {
    font-size: 13px;
  }
`;

export const IconAlert = styled.img`
  width: 16px;
  height: 16px;
  margin-right: 10px;
  margin-top: 4px;
`;

export const ContentAlert = styled.div`
  display: flex;
  align-items: center;
`;

export const ContainerInput = styled.div`
  display: grid;
  grid-template-columns: 42px 42px 42px 42px 42px 42px;
  justify-content: space-between;

  @media (max-width: 650px) {
    grid-template-columns: 33px 33px 33px 33px 33px 33px;
  }
`;
